import { api } from '$lib/utils/api';
import { createQuery } from '@tanstack/svelte-query';

export const useUsersQuery = (props, options = {}) => {
  return createQuery({
    queryKey: ['users'],
    queryFn: () => api().get(`v2/user/all`),
    ...options,
  });
};

export const getActiveUsers = () =>
  createQuery({
    queryKey: ['activeUsers'],
    queryFn: () => api().get(`v2/user/active`),
  });

export const getUser = (id) =>
  createQuery({
    queryKey: ['user', id],
    queryFn: () => api().get(`nurse/users/${id}`),
  });

export const userQueryOptions = (id) => ({
  queryKey: ['user', id],
  queryFn: () => api().get(`nurse/users/${id}`),
});

export const useUserQuery = (props, options = {}) => {
  const { id } = props;
  return createQuery({
    ...userQueryOptions(id),
    ...options,
  });
};

export const addUser = (user) => api().post(`nurse/users/`, { ...user });

export const removeUser = (id) => api().post(`nurse/users/inactivate/${id}`);

export const editUser = (clientData) =>
  api().put(`nurse/users/${clientData.id}`, { ...clientData });

export const getUserLanguages = (id) =>
  createQuery({
    queryKey: ['userLanguages', id],
    queryFn: () => api().get(`v2/user/${id}/languages`),
  });

export const updateUserLanguages = (id, languageIds) =>
  api().put(`v2/user/${id}/languages`, { languageIds });
